import React from "react";
import NavBar from "../navbar/NavBar";
import Home from "../home/Home";
import Services from "../offering/Services";
import Tittle from "../Title/Tittle";
import About from "../about/About";
import Contact from "../contact/Contact";
import Footer from "../footer/Footer";

const Homepage = () => {
  return (
    <div>
      <NavBar/>
      <Home/>
      <div className="container">
        <Tittle subTitle='Our Specialization' title='What We Offer'/>
        <Services/>
        <About/>
        <Tittle subTitle='Contact us' title='Get in Touch'/>
        <Contact/>
        <Footer/>
      </div>
    </div>
  )
}

export default Homepage;
